export default function(state = [], action){
    switch(action.type){
        case "SET_ADDRESS_BOOK":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/addressBook.js